<template>
  <div>
    <div class="share">
      <div class="share-content" :style="{ 'border-bottom': border == true ? '2px solid rgb(233, 234, 236)' : '' }">
        <div
          :class="fontSize == 2 ? 'share-box min-share-btn' : fontSize == 1 ? 'share-box min-share-btn titleSmall' : 'share-box min-share-btn titleBig'"
          type="default" size="mini" @click="favorArticle">
          <img
            :class="fontSize == 2 ? 'share-image' : fontSize == 1 ? 'share-image titleSmall' : 'share-image titleBig'"
            src="../../assets/article/shoucang.png" mode="widthFix" />
          <span>{{ inFavor ? '取消收藏' : '收藏本文' }}</span>
        </div>
        <div
          :class="fontSize == 2 ? 'share-box min-share-btn' : fontSize == 1 ? 'share-box min-share-btn titleSmall' : 'share-box min-share-btn titleBig'"
          type="default" size="mini" @click="getPoster()">
          <img
            :class="fontSize == 2 ? 'share-image' : fontSize == 1 ? 'share-image titleSmall' : 'share-image titleBig'"
            src="../../assets/article/haibao.png" mode="widthFix" />
          <span>分享海报</span>
        </div>
        <div
          :class="fontSize == 2 ? 'share-box min-share-btn' : fontSize == 1 ? 'share-box min-share-btn titleSmall' : 'share-box min-share-btn titleBig'"
          type="default" size="mini" @click="toCopy()">
          <img
            :class="fontSize == 2 ? 'share-image' : fontSize == 1 ? 'share-image titleSmall' : 'share-image titleBig'"
            src="../../assets/article/copy.png" mode="widthFix" />
          <span>复制全文</span>
        </div>
      </div>
    </div>
  </div>
  <a-modal v-model:visible="posterView" centered @ok="handleOk" style="width: 600px;" destroyOnClose>
    <div style="margin-top: 20px">
      <div class="postWrap" ref="poster" id="poster" :style="{ background: 'url(' + imgsrc + ') no-repeat' }">
        <img style="padding-top: 20px; height: 100%; width: 90%" src="../../assets/background1.png" />
        <div class="item" id="item">
          <div>
            <div id="content" :class="article.productType == 5 ? 'contentItem proncontentItem' : 'contentItem'
              "></div>
            <div class="shareWrap">
              <div style="padding: 20px 20px 24px 20px; display: flex; width: 100%">
                <div id="qrcode" ref="qrcode"></div>
                <div class="shareText">
                  <div>
                    <div>长按识别查看</div>
                    <div>更多情报内容</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex;    justify-content: center;margin-top: 20px;">
        <a-button @click="saveShare()">下载此海报</a-button>
      </div>
    </div>
    <template #footer></template>
  </a-modal>
</template>
<script>
import useClipboard from 'vue-clipboard3'
import html2toCanvas from "html2canvas";
import QRCode from "qrcodejs2";
import $ from "jquery";
import { favor, articleInfor } from './js/index'
import { message } from 'ant-design-vue';
import { ref, nextTick, watch, onMounted } from 'vue';
import store from '@/store';
import { toDoArticleRecord } from '../homePageComponent/js';
export default {
  name: 'Share',
  props: {
    article: { type: Object, default: null },
    content: {
      type: String,
      default: ""
    },
    border: { type: Boolean, default: false }
  },
  setup(props) {


    watch(() => store.getters.fontSize, (val, oldVal) => {
      fontSize.value = val
    })
    watch(() => props.article, (val, oldVal) => {
      if (val) {
        inFavor.value = props.article.inFavor
      }
    })
    onMounted(() => {
      fontSize.value = store.getters.fontSize
    })
    const posterView = ref(false)
    const qrcode = ref(null)
    const poster = ref(null)
    const getPoster = (val) => {
     
        toDoArticleRecord(props.article.id, 1)
        posterView.value = true

        nextTick(() => {
          new QRCode(qrcode.value, {
            width: 80, // 设置宽度
            height: 80, // 设置高度
            text: "https://mp.weixin.qq.com/s/uh9a9Ga_BM9xyPp7yLTuVA"
          })
          nextTick(async () => {
            await toGetArticle().then(() => {
              document.getElementById("content").innerHTML = ''
              if (props.article.productType == 5) {
                var result = JSON.parse(content.value);
                result = result.filter(item => item.daily_report_id == null)
                var list = "";
                for (var i in result) {
                  var articleCategoryClass = result[i].secondaryArticleCategory
                    ? "inline-title1"
                    : "inline-title";
                  list =
                    list +
                    '<div class="article-title"><div class=' +
                    articleCategoryClass +
                    ">" +
                    '<div class="inline-content"><text class="article-category-name">【' +
                    result[i].articleCategory +
                    "】</text><text >" +
                    result[i].title +
                    "</text></div></div>";

                  list = list + '<div style="padding-bottom:20px">'


                  if (result[i].introduction)
                    list = list +
                      '<div class="introduce">' + result[i].introduction + '</div></div>'
                  else list = list + '</div>'



                  if (result[i].secondaryArticleCategory) {
                    list =
                      list +
                      '<div class="secondary"><div class="bg-blue"><text class="text-s">' +
                      result[i].secondaryArticleCategory +
                      "</text>	</div></div>";
                  }
                  list = list + "</div>";
                }
                document.getElementById("content").innerHTML = list;
              } else {
                var htmlContent=  content.value
                console.log(props.article.articleCategoryId,'props.article.articleCategoryId')
                if(props.article.articleCategoryId == 216) {
                  htmlContent= htmlContent.replace(/<a[^>]*>.*?<\/a>/g, '')
                }
                document.getElementById("content").innerHTML =
                (props.article.articleCategoryId == 216?'':('<div class="contentTitle">' +
                  props.article.title +
                  "</div>"))
                   +
                  "<div class='content' id='content'>" +
                  htmlContent +
                  "</div>" +
                  "<div class='time'>" +
                  props.article.updateTime +
                  "</div>";
              }
              $("#content")
                .find("img")
                .each(async function (i, elem) {
                  if ($(elem)[0].src.indexOf("https://enplus.oss") == -1) {
                    $(elem).parent().attr("style", "display:none;");
                  }
                });
            })
              ;
          })
        })

    
    }
    const favorArticle = () => {
      inFavor.value = !inFavor.value
      let inFavorValue = inFavor.value ? 'true' : 'false'
      favor({
        id: props.article.id, data: {
          companyId: store.getters.company.companyId,
          inFavor: inFavorValue
        }
      }).then(() => {
        message.success(
          (inFavorValue === 'false' ? '取消' : '') + '收藏成功',
          10,
        );
        if (window.location.href.indexOf('favor') == -1)
          store.dispatch('reloadFavorFlag', true)
      })
    }
    const inFavor = ref(props.article.inFavor)
    const toCopy = async () => {
      const { toClipboard } = useClipboard()
      await toGetArticle().then(async () => {
        var contentC = ''
        if (props.article.articleCategoryId == 55) {
          var list = JSON.parse(content.value)
          if (!(list instanceof Array)) {
            list = []
          }
          if (list.length == 0 || list.filter(item => item.daily_report_id == null).length == 0) {
            return;
          }
          list = list.filter(item => item.daily_report_id == null)
          contentC = props.article.title + "\n" + props.article.updateTime + " 情报强企" + "\n"
          list.forEach((item, index) => {
            contentC = contentC + (index + 1) + "、【" + item.articleCategory + "】" + item.title + "\n"
          })
        }
        else {


          if (props.content && props.content != "") {
            contentC = props.content
          }
          else {
            contentC = content.value
          }
          if (props.article.articleCategoryId == 216) {
            //删除a标签
            contentC = contentC.replace(/<a[^>]*>.*?<\/a>/g, '')
            console.log(contentC, '周报内容')

            contentC =  contentC.replace(/<\/?(?:span|text|strong)[^>]*>/g, '')

          }


          contentC = contentC.replace(/<img [^\>]*\/>/g, '')

          contentC = contentC.replace(/<[^>]+>/g, "\n")
          contentC = contentC.replace(/\n+/g, '\n')
          contentC=contentC.replace(/&nbsp;/g, '')
          if(props.article.articleCategoryId != 216)

          contentC = props.article.title + "\n" + props.article.updateTime + " 情报强企" + contentC
        }
        try {

          await toClipboard(contentC.trim())
          message.success('复制成功', 10);
        } catch (err) {
          console.error('复制失败:', err);
          message.error('复制失败，请手动复制', 10);
        }
      })



    }
    const saveShare = () => {
      setTimeout(() => {
        html2toCanvas(poster.value, {
          background: null,
          tainttest: true,
          useCORS: true,
          scrollX: 0,
          scrollY: 0,
          scale: 2,
          allowTaint: false,
        }).then((canvas) => {
          var img = canvas.toDataURL("image/png");
          if (img) {
            var a = document.createElement('a') // 创建一个a节点插入的document
            var event = new MouseEvent('click') // 模拟鼠标click点击事件
            a.download = '情报强企-' + props.article.title // 设置a节点的download属性值
            a.href = img // 将图片的src赋值给a节点的href
            a.dispatchEvent(event) // 触发鼠标点击事件
            message.success("海报下载成功")
            posterView.value = false
          }
        }),
          3000
      })
    }
    const src = ref('')
    const fontSize = ref('')
    const content = ref('')
    const toGetArticle = () => {
      return new Promise((resolve, reject) => {
        articleInfor({ id: props.article.id }).then((res) => {
          content.value = res.data.content

          resolve()
        })
      })
    }
    return {
      content,
      toGetArticle,
      fontSize,
      src,
      saveShare,
      toCopy,
      imgsrc: require("../../assets/background2.jpg"),
      favorArticle,
      inFavor,
      getPoster,
      qrcode,
      poster,
      posterView
    }
  }
}
</script>
<style lang="less">
.introduce {
  color: #888e90;

  font-size: 13px;
  line-height: 22px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
  padding: 0px 12px 0px 12px;
  text-align: justify;
}


.share-box {
  cursor: pointer;
}

.share-box:hover {
  color: #009da6 !important;
  ;
}

.content img {
  max-width: 100%;
}

.contentTitle {
  padding: 0px 20px 20px 20px;
  font-family: "PingFang SC";
  font-weight: 500;
  font-size: 20px;
  text-align: justify;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
}

.postWrap {
  width: 548px;
  text-align: center;
  background-size: 100% 99.9% !important;
  //background-size: cover  !important;
  background-attachment: fixed !important;
}

.article-title {
  padding: 0px;
  background-color: #ffffff;
  border-radius: 16px;
  margin-bottom: 10px;
}

.inline-title {
  padding: 10px 5px 10px 5px;
  display: flex;
}

.inline-title1 {
  padding: 24px 0px 0px 0px;
  display: flex;
}

.inline-img {
  width: 24px;
  height: 24px;
}

.inline-content {
  color: rgba(0, 0, 0, 0.9);
  text-align: left;
  font-size: 16px;
}

.secondary {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  font-size: 24px;
}

.bg-blue {
  background-color: #009da6;
  border-radius: 16px 0px 16px 0px;
  width: 128px;
  height: 48px;
}

.text-s {
  color: #ffffff;
  text-align: center;
  line-height: 48px;
  font-weight: bold;
  padding-left: 16px;
}

.article-category-name {
  color: #009da6;
  font-weight: bold;
}

.item {
  padding: 20px;
}

.contentItem {
  width: 100%;
  border-radius: 8px 8px 0px 0px;
  background: white;
  padding: 24px 0px 24px 0px;
  text-align: left;
}

.proncontentItem {
  background: #f7f7f7;
  padding: 20px;
}

.time {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  text-align: right;
  letter-spacing: 0.02em;
  line-height: 20px;
  font-family: "PingFang SC";
  padding: 0px 20px 0 20px;
}

.shareWrap {
  background: #009da6;
  display: flex;
  width: 100%;
  border-radius: 0 0px 8px 8px;
}

.shareText {
  justify-content: flex-end;
  width: 100%;
  display: flex;
  color: white;
  align-items: flex-end;
  font-size: 14px;
}
</style>
<style lang="scss" scoped>
@import '../../assets/style.scss';



.share .share-content .share-box.titleBig {
  font-size: 16px;
}

.share .share-content .share-box.titleSmall {
  font-size: 12px;
}

.share {
  .share-content {
    cursor: default;
    margin-top: 0px;
    padding: 20px 0px 10px 20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 16px;


    .share-box {
      display: flex;
      align-items: center;
      padding: 0;
      margin: 0;
      background-color: transparent;
      border: 0;
      font-size: 14px;
      color: #2b2b2b;

      &::after {
        border: 0;
      }

      &.min-share-btn {
        min-width: 140px;
      }

      .share-image.titleSmall {
        width: 12px;
      }

      .share-image.titleBig {
        width: 16px;
      }

      .share-image {
        width: 14px;
        height: auto;
        margin-right: 8px;

        &.share-1 {
          width: 30px;
        }
      }
    }
  }
}
#content .ai-category  {
    padding:0px 20px 20px 20px;
}
</style>
